<template>
    <div class="gofixTab" v-bind:class="{
        gofixTabHasArrow:arrows
    }">
        <div class="gofixTabHeader">
            <div class="gofixTabControl" v-if="arrows">
                <ul class="gofixTabControlInner">
                    <li class="gofixtabArrow" @click="prevTab">
                        <img src="img/leftIcon.png" alt="">
                    </li>
                    <li class="gofixtabArrow" @click="nextTab">
                        <img src="img/rightIcon.png" alt="">
                    </li>
                </ul>
            </div>
            <VueSlickCarousel v-bind="settings" ref="gofixTabCarousel">
                <div class="gofixTabHeaderItem" v-bind:class="[{active : tab.active}, {'min-width-140': variableWidth},{'gofixTabDisabled' : tab.disabled}]" v-for="tab in tabs" :key="tab.key">
                    <span @click="handleTab(tab)" :class="{ 'pr-25 pl-25': variableWidth }">
                        <slot :name="'gofixTab:before-title:' + tab.key"></slot>
                        {{tab.title}}
                        <slot :name="'gofixTab:after-title:' + tab.key"></slot>
                    </span>
                </div>
                <div class="gofixTabHeaderItem hidden" :class="{ 'd-none': variableWidth }">
                    <span>hidden</span>
                </div>
            </VueSlickCarousel>
            <div class="gofixTabHeaderRight pr-4"><slot name="gofixTab:right"></slot></div>
        </div>
        <div :class="['gofixTabContent', classTabContent]">
            <div class="gofixTabContentItem" v-for="tab in tabs" :key="tab.key" v-if="tab.active || showFullTab" v-show="tab.active">
                <slot :name="'gofixTab:' + tab.key"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        name: "gofix-tab",
        props: {
            arrows: {
                type: Boolean,
                required: false,
                default: () => false
            },
            data:{
                type: Array,
                required: true,
                default: () => []
            },
            queryParam:{
                type: Object,
                required: false,
                default: () => null
            },
            activeKey:{
                type: String,
                required: false,
                default: () => null
            },
            showFullTab:{
                type: Boolean,
                required: false,
                default: () => false
            },
            variableWidth:{
                type: Boolean,
                required: false,
                default: () => false
            },
            classTabContent: {
                type: String,
                required: false,
                default: ''
            },
            isReloadTab:{
                type: Boolean,
                required: false,
                default: () => false
            },
            responsive:{
                type: Array,
                required: false,
                default: () => {
                    return  [
                        {
                            breakpoint: 1920,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1367,
                            settings: {
                                slidesToShow: 7,
                                slidesToScroll: 3
                            }
                        }
                    ];
                }
            }
        },
        data() {
            return {
                tabs: this.data,
                settings:{
                    "dots": false,
                    "arrows": false,
                    "focusOnSelect": false,
                    "infinite": false,
                    "touchMove": true,
                    "swipe": true,
                    "swipeToSlide": true,
                    "speed": 500,
                    "slidesToShow": 10,
                    "slidesToScroll": 3,
                    "variableWidth": false,
                    "centerPadding": "100px",
                    responsive: this.responsive
                }
            }
        },
        components: { VueSlickCarousel },
        created(){
            this.settings.variableWidth = this.variableWidth
            if(this.activeKey){
                for (var i in this.data) {
                    if(this.data[i].key === this.activeKey){
                        this.data[i].active = true;
                    }else{
                        this.data[i].active = false;
                    }
                }
            }
        },
        watch: {
            data : function(val){
                this.tabs = val;
            }
        },
        mounted () {
            this.tabs.forEach((element, index) => {
                if(element.active) {
                    const num = Math.floor(index / 7);
                    if(num >= 1){
                        this.$refs.gofixTabCarousel.goTo(num * 7)
                    }
                }
            });
            
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleResize);
                this.handleResize();
            })
        },
        updated() {
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            handleResize() {
                let clientWidth = this.$el.querySelector('.gofixTabHeaderRight').clientWidth;
                if(clientWidth == 24) clientWidth = 0;
                this.$el.querySelector('.slick-slider').style.width = `calc(100% - ${clientWidth + 30}px)`
                if(this.variableWidth) {
                    this.$el.querySelector('.slick-track').style.cssText = this.$el.querySelector('.slick-track').style.cssText + 'min-width: 100vw !important';
                }
            },
            prevTab(){
                this.$refs.gofixTabCarousel.prev()
            },
            nextTab(){
                this.$refs.gofixTabCarousel.next()
            },
            async handleTab(tab){
                if(tab.active || tab.disabled){
                    return ;
                }
                if(!tab.link){
                    this.tabs.forEach((element, index) => {
                        this.tabs[index].active = false;
                    });
                    tab.active = true;
                    this.$emit("load-tab",tab);
                }else{
                    let url =  tab.link.toString();
                    let firstData = url.split("/{");
                    firstData.forEach(element => {
                        let childData = element.split("}");
                        if(childData.length >= 2){
                            url = url.replace(`{${childData[0]}}`,this.queryParam[childData[0]]);
                        }
                    });
                    this.$router.push(url)
                }

                if(this.isReloadTab) this.reloadTab();
            },
            reloadTab() {
                let count = this.tabs.length;
                this.tabs.forEach((element, index) => {
                    if(element.active) {
                        const num = Math.floor(index / count);
                        let goTo = (index - 1);
                        if(num >= 1){
                            goTo = num * count;
                        }

                        this.$refs.gofixTabCarousel.goTo(goTo)
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
